import React from "react";

const EditIcon = ({
  disabled = false,
  width = "20.586",
  height = "20.605",
  cursor = "auto",
}) => {
  return disabled ? (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20.586"
      height="20.605"
      viewBox="0 0 20.586 20.605"
      style={{ cursor: cursor }}
    >
      <g
        id="Group_1151"
        data-name="Group 1151"
        transform="translate(-2.5 -2.425)"
        opacity="0.2"
      >
        <path
          id="Path_1207"
          data-name="Path 1207"
          d="M18.277,30.277H4.711V16.711h7.824L14.745,14.5H3.605A1.11,1.11,0,0,0,2.5,15.605V31.382a1.1,1.1,0,0,0,1.105,1.105H19.382a1.11,1.11,0,0,0,1.105-1.105V20.243l-2.211,2.232Z"
          transform="translate(0 -9.458)"
        />
        <rect
          id="Rectangle_3465"
          data-name="Rectangle 3465"
          width="9.861"
          height="4.573"
          transform="translate(10.047 12.255) rotate(-45)"
        />
        <path
          id="Path_1208"
          data-name="Path 1208"
          d="M79.916,4.89,77.662,2.636a.694.694,0,0,0-1,0L75.3,4l3.229,3.229,1.365-1.365A.687.687,0,0,0,79.916,4.89Z"
          transform="translate(-57.023 0)"
        />
        <path
          id="Path_1209"
          data-name="Path 1209"
          d="M25.273,54.475a.732.732,0,0,0-.2.412l-.3,2.557a.7.7,0,0,0,.78.78l2.557-.3a.732.732,0,0,0,.412-.2l.975-.975L26.226,53.5Z"
          transform="translate(-17.441 -40.006)"
        />
      </g>
    </svg>
  ) : (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width ? width : "20.586"}
      height={height ? height : "20.605"}
      viewBox="0 0 20.586 20.605"
      style={{ cursor: cursor }}
    >
      <g
        id="Group_1097"
        data-name="Group 1097"
        transform="translate(-2.5 -2.425)"
      >
        <path
          id="Path_1207"
          data-name="Path 1207"
          d="M18.277,30.277H4.711V16.711h7.824L14.745,14.5H3.605A1.11,1.11,0,0,0,2.5,15.605V31.382a1.1,1.1,0,0,0,1.105,1.105H19.382a1.11,1.11,0,0,0,1.105-1.105V20.243l-2.211,2.232Z"
          transform="translate(0 -9.458)"
        />
        <rect
          id="Rectangle_3465"
          data-name="Rectangle 3465"
          width="9.861"
          height="4.573"
          transform="translate(10.047 12.255) rotate(-45)"
        />
        <path
          id="Path_1208"
          data-name="Path 1208"
          d="M79.916,4.89,77.662,2.636a.694.694,0,0,0-1,0L75.3,4l3.229,3.229,1.365-1.365A.687.687,0,0,0,79.916,4.89Z"
          transform="translate(-57.023 0)"
        />
        <path
          id="Path_1209"
          data-name="Path 1209"
          d="M25.273,54.475a.732.732,0,0,0-.2.412l-.3,2.557a.7.7,0,0,0,.78.78l2.557-.3a.732.732,0,0,0,.412-.2l.975-.975L26.226,53.5Z"
          transform="translate(-17.441 -40.006)"
        />
      </g>
    </svg>
  );
};

export default EditIcon;
